import lodash from "lodash";

export const createReloadItems = ({ data, props }) => {
    return () => {
        data.isLoading = true;
        const result = props.list({});
        if (result instanceof Promise) {
            result.then((items) => {
                data.items = items;
                data.isLoading = false;
            });
        } else {
            data.items = result;
            data.isLoading = false;
        }
    };
};

export const createOnUpdateValue = ({ data, props, emit }) => {
    return (value) => {
        data.searchQuery = "";
        if (!props.mode) {
            if (value) {
                value = getItems({ data, props }).find((d) => value === getKeyValue({ record: d, props }));
            }
            emit("update:value", lodash.cloneDeep(value));
        }
    };
};

export const getValues = ({ props }) => {
    return getKeyValue({ record: props.value, props });
};

export const getItems = ({ data }) => {
    return data.items;
};

export const getKeyValue = ({ record, props }) => {
    if (!record) {
        return null;
    }
    if (props.rowKey) {
        return props.rowKey({ record });
    }
    return lodash.get(record, props.optKey);
};
